import React, { useEffect } from "react";
import ModalContainer from "./ModalContainer"; // adjust import path if needed
import { useNavigate } from "react-router-dom";
import Paths from "../router/Paths";

const contentMap = {
  cap: {
    title: "You Won a Cap 🎉",
    body: "Congratulations! Your spin landed on a Cap. It will be handed to you at the booth.",
    img: "/cap.png",
  },
  shirt: {
    title: "You Won a T-Shirt 🎉",
    body: "Congratulations! Your spin landed on a T-Shirt. It will be handed to you at the booth.",
    img: "/shirt.png",
  },
  bag: {
    title: "You Won a Tote Bag 🎉",
    body: "Congratulations! Your spin landed on a Tote Bag. It will be handed to you at the booth.",
    img: "/bag.png",
  },
  notepad: {
    title: "You Won a Notepad 🎉",
    body: "Congratulations! Your spin landed on a Notepad. It will be handed to you at the booth.",
    img: "/notepad.png",
  },
  pad: {
    title: "You Won a Writing Pad 🎉",
    body: "Congratulations! Your spin landed on a Writing Pad. It will be handed to you at the booth.",
    img: "/pad.png",
  },
  sub3: {
    title: "You Won 3 Months Subscription 🎉",
    body: "Congratulations! Your spin landed on a 3 Months Subscription. It has been added to your account.",
    img: "/subscription.png",
  },
  airtime1k: {
    title: "You Won 1,000 Airtime 🎉",
    body: "Congratulations! Your spin landed on airtime. It will be handed to you at the booth.",
    img: "/airtime1k.png",
  },
  airtime5k: {
    title: "You Won 5,000 Airtime 🎉",
    body: "Congratulations! Your spin landed on airtime. It will be handed to you at the booth.",
    img: "/airtime5k.png",
  },
  mystery: {
    title: "You Won Mystery Gift 🎉",
    body: "Congratulations! Your spin landed on mystery gift. It will be handed to you at the booth.",
    img: "/mystery.png",
  },
  try: {
    title: "Try Again 🔄",
    body: "No reward this time. Spin once more for a chance to win.",
    img: "/try.png",
  },
};

const fallback = {
  title: "Prize",
  body: "You have a prize waiting!",
  img: "/cap.png",
};

export default function PrizeModal({
  open,
  setOpen,
  onClaim,
  onTryAgain,
  code,
}) {
  const data = contentMap[code] || fallback;

  // close on ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, setOpen]);

  const handlePrimary = () => {
    // navigate(Paths.claim);
    setOpen(false);
    if (code === "try") {
      onTryAgain?.();
    } else {
      onClaim?.(code);
    }
  };

  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      onClickOutside={() => setOpen(false)}
      // hide built-in header; we’ll render a card-like body instead
      header={<></>}
      padding="p-4" // we’ll manage padding inside
      childClassname="max-w-sm flex " // mobile-first card size
    >
      {/* Card */}
      <div className="w-full rounded-2xl overflow-hidden shadow-2xl ">
        {/* Image (already contains its own background; center it) */}
        <div className="w-full ">
          <img
            src={data.img}
            alt={code}
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Content */}
        <div className="px-5 pb-5 pt-2 bg-white">
          <h3 className="text-xl font-bold text-center">{data.title}</h3>
          <p className="mt-2 text-gray-600 text-center">{data.body}</p>

          <button
            type="button"
            onClick={handlePrimary}
            className="mt-4 w-full rounded-md py-3 text-white font-semibold
                       bg-gradient-to-r from-blue-500 to-blue-600 shadow-sm active:scale-[.99]"
          >
            {code === "try" ? "Try Again" : "Claim"}
          </button>
        </div>
      </div>
    </ModalContainer>
  );
}
